import { Redirect, useHistory, useLocation } from 'quartz-routing/react-router';
import { EmbeddedContentPage } from '../components/EmbeddedContentPage';
import { Paths } from '../constants/Paths';
import { IFRAME_MESSAGE_TYPES } from '../constants/IFrameMessages';
import { trackInteraction } from '../utils/usageTracker';
import { Metrics } from '../utils/Metrics';
import { useAppDispatch } from '../redux';
import { completePaymentMethodUpdate } from '../features/PaymentMethodUpdate/PaymentMethodUpdateSlice';
import { jsx as _jsx } from "react/jsx-runtime";
export function UpdatePaymentMethod() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const params = new URLSearchParams(location.search);
  const updatePaymentUrl = params.get('url');
  if (!updatePaymentUrl) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: Paths.SUBSCRIPTIONS
    });
  }
  return /*#__PURE__*/_jsx(EmbeddedContentPage, {
    src: updatePaymentUrl,
    title: "Update Payment Method",
    subscreen: "update-payment-method",
    breadcrumbs: [{
      label: 'updatePaymentMethod.breadcrumb.subscriptions',
      href: Paths.SUBSCRIPTIONS
    }, {
      label: 'updatePaymentMethod.breadcrumb.updatePaymentMethod'
    }],
    onMessage: msg => {
      var _msg$payload;
      if (((_msg$payload = msg.payload) === null || _msg$payload === void 0 ? void 0 : _msg$payload.type) === IFRAME_MESSAGE_TYPES.SUCCESS) {
        Metrics.counter('payment-method-updated').increment();
        trackInteraction('payment-method-updated');
        dispatch(completePaymentMethodUpdate());
        history.push(Paths.SUBSCRIPTIONS);
      }
    }
  });
}